import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as R from 'ramda'
import * as actions from '../actions'
import PageHeader from './page-header'
import Loader from './loader'

class CheckOTP extends React.Component {
  constructor(props) {
    super(props)
    this.state = { showResendHint: false }
  }
  componentWillMount() {
    const { showResend } = this.props
    showResend()
  }

  setHintTimer = () => this.hintTimeout = setTimeout(
    () => this.setState({ showResendHint: true }),
    30 * 1000
  )
  clearHintTimer = () => this.hintTimeout && clearTimeout(this.hintTimeout)

  resetHintTimer = () => {
    this.clearHintTimer()
    this.setHintTimer()
  }

  componentDidMount() {
    this.setHintTimer()
  }

  componentWillUnmount() {
    this.clearHintTimer()
  }

  render() {
    const { loading, user, emailOtp, resendSms, postOtp, handleSubmit, pristine, submitting, valid } = this.props
    const { showResendHint } = this.state

    const requestEmail = () => {
      emailOtp()
      this.setState({ showResendHint: false })
      this.resetHintTimer()
    }

    const requestResend = () => {
      resendSms()
      this.setState({ showResendHint: false })
      this.resetHintTimer()
    }

    return (
      <div>
        <PageHeader title={"One Time Pin (OTP)"}/>
        <div className='container'>
          <div className='alert alert-info'>
            { !showResendHint &&
              <p>
                A one-time password (OTP) has been sent to you.
              </p>
            }
            { showResendHint &&
              <div>
                <p>
                  Didn&#29;t receive the OTP (one-time password)?
                </p>
                <div>
                  <button
                    style={{ marginRight: 10, marginBottom: 10 }}
                    className="btn btn-info btn-sm"
                    onClick={requestResend}>
                    Send Again
                  </button>
                  { user && user.hasEmail &&
                    <button
                      style={{ marginBottom: 10 }}
                      className="btn btn-primary btn-sm"
                      onClick={requestEmail}>
                      Send via Email
                    </button>
                  }
                </div>
                <p>
                  If you need to
                  change your cellphone number or email address, or need help logging in,
                  please
                  contact support@da.org.za or call 021 465 1431
                </p>
              </div>
            }
          </div>
        </div>
        <div className='content'>
          <div className='container'>
            <form onSubmit={handleSubmit(postOtp)}>
              <div className='form-group'>
                <Field
                  component='input'
                  autoComplete='off'
                  readOnly={submitting || loading}
                  type='tel'
                  name='otp'
                  autoFocus={true}
                  className='form-control'
                  placeholder='Enter your one time pin (OTP)...'
                  required
                />
              </div>
              <button
                disabled={pristine || submitting || !valid}
                className={'btn btn-success btn-block'}>
                  { loading ? <Loader/> : 'Check' }
              </button>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  const {user, loading, redirecting, otpsPosted} = state
  console.log('mapStateToProps, otpsPosted', otpsPosted)
  return {
    user: user.user,
    loading: loading || redirecting,
    otpsPosted,
    ...ownProps
  }
}

function mapDispatchToProps(dispatch) {
  return ({
    emailOtp: bindActionCreators(actions.emailOtp, dispatch),
    resendSms: bindActionCreators(actions.resendSms, dispatch),
    postOtp: bindActionCreators(actions.postOtp, dispatch),
    showResend: bindActionCreators(actions.showResend, dispatch)
  })
}

const validate = values => {
  const errors = {}
  if (!values.otp) {
    errors.otp = 'OTP (one time password) is required'
  } else {
    if (values.otp && values.otp.length < 4) {
      errors.otp = 'OTP too short'
    }
  }
  return errors
}

CheckOTP = reduxForm({
  form: 'otp',
  validate,
  onChange: (values, dispatch, props) => {
    const { otp } = values
    const { otpsPosted } = props
    console.log('otp, otpsPosted', otp, otpsPosted)
    if (!validate(values).otp && otp.length === 4 && !R.contains(otp, otpsPosted)) {
      dispatch(actions.postOtp(values))
    }
  }
})(connect(mapStateToProps, mapDispatchToProps)(CheckOTP))

export default connect(state => ({ otpsPosted: state.otpsPosted }))(CheckOTP)



// WEBPACK FOOTER //
// ./src/app/components/check-otp.js